export default {
    // This regex should be kept in sync with UT_API/Constants/RegexConstants.cs
    email: /^[\p{L}\p{N}!#$%&*+/=?^_`{|}~-]+(?:\.[\p{L}\p{N}!#$%&*+/=?^_`{|}~-]+)*@(?:[\p{L}\p{N}]+(?:-[\p{L}\p{N}]+)*\.)+\p{L}{2,}$/u,
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=[\]{}|;'/:<>?~.`," ]{8,100}$/,
    phoneNumber: /^\(?(\d{3})\)?[-. ]?(\d{3})[-. ]?(\d{4})$/,
    zipCode: /^\d{5}(?:[-\s]\d{4})?$/,
    url: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.][a-z0-9]+)*\.[a-z]{2,18}(:\d{1,5})?(\/.*)?$/i,
};
